import { Add } from '@material-ui/icons';
import { Grid } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock } from '~/Components/Icons';
import { IconButton, Switch, Typography } from '~/UIKit';
import { OpeningHoursSectionStyles } from '..';

export interface IOpeningHoursSectionTableCloseRowProps {
  currentDay: string;
  onToggleDay: (day: string, timeIndex?: number) => void;
}

export const OpeningHoursSectionTableCloseRow = ({
  currentDay,
  onToggleDay,
}: IOpeningHoursSectionTableCloseRowProps) => {
  const { t } = useTranslation();
  const { classes } = OpeningHoursSectionStyles();

  return (
    <Grid container>
      <Grid
        className={classNames(classes.dayRow, classes.inactive, classes.hasBottomBorder)}
        alignItems="center"
        md={3}
        container
      >
        <Grid className={classes.iconWrapper}>
          <Clock />
        </Grid>
        <span className={classes.itemRow}>{t(`app.weekdays.${currentDay}`)}</span>
      </Grid>
      <Grid
        container
        md={1}
        justifyContent="center"
        className={classNames(classes.inactive, classes.row, classes.hasBottomBorder)}
      >
        <Switch checked={false} onChange={() => onToggleDay(currentDay)} />
      </Grid>

      <Grid md={5} container className={classes.row}>
        <Grid
          item
          md={2}
          className={classNames(classes.inactive, classes.row, classes.hasBottomBorder)}
        >
          &nbsp;
        </Grid>
        <Grid
          data-testid="opening-hours-section-close-block"
          md={8}
          className={classNames(classes.inactive, classes.row, classes.hasBottomBorder)}
          justifyContent="center"
          alignItems="center"
          container
        >
          <Typography className={classes.closeLabel}>{t('app.closed')}</Typography>
        </Grid>
        <Grid
          item
          md={2}
          className={classNames(classes.inactive, classes.row, classes.hasBottomBorder)}
        >
          &nbsp;
        </Grid>
      </Grid>

      <Grid container alignItems="center" justifyContent="center" md={3} alignSelf="start">
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          md={12}
          className={classNames(classes.row, classes.actionCol)}
        >
          <Grid container alignItems="center" justifyContent="center" md={3}>
            <IconButton
              onClick={() => onToggleDay(currentDay)}
              className={classes.addButton}
              size="medium"
            >
              <Add />
            </IconButton>
          </Grid>
          <Grid
            container
            item
            md={8}
            display={{ xs: 'none', md: 'flex' }}
            justifyContent="flex-end"
          >
            &nbsp;
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
